import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { OccProductSearchAdapter } from '@spartacus/core';
import { FacetListComponent, FacetService } from '@spartacus/storefront';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProductListService } from '../../../../kbs-site-doc-search-page/service/Product-list/product-list.service';


@Component({
  selector: 'app-facet-list-kb',
  templateUrl: './facet-list-kb.component.html',
  styleUrls: ['./facet-list-kb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class FacetListKbComponent extends FacetListComponent implements OnInit {


  facetTabIndex: any = 0;
  docOrSoftware: boolean = false;

  constructor(
    facetService: FacetService,
    elementRef: ElementRef,
    renderer: Renderer2,
    public productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    private cdr: ChangeDetectorRef
  ) {
    super(facetService, elementRef, renderer);
  }
  override ngOnInit() {
    super.ngOnInit();
    this.productListService.selectedTabIndex.subscribe((data) => {
      this.facetTabIndex = data;
      if (this.facetTabIndex == 7 || this.facetTabIndex == 8) {
        this.docOrSoftware = true;
      } else {
        this.docOrSoftware = false;
      }
      this.cdr.detectChanges();
    });
  }
}
